export const TAILSCALE_DOCTOR = {
  "version": "1.3.0",
  "fileName": "Tailscale-Doctor-1.3.0-arm64.zip",
  "downloadUrl": "/downloads/tailscale-doctor/Tailscale-Doctor-1.3.0-arm64.zip",
  "sizeLabel": "1.42 MB",
  "sha256": "c7555bf6bc0fb8d4a38d30bc6f625fad807687d4024eaa69dc44724e1fa5a521"
};
